import { Component, OnInit } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { EnvironmentconfigService } from 'src/app/shared/service/environmentconfig.service';
import { URLConst } from '../shared/const/url.const';
import { WebApiService } from '../shared/service/webapi.service';
import { AuthService } from '../shared/auth/auth.service';
import { LayoutService } from '../shared/auth/layout-service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzSpinModule } from 'ng-zorro-antd/spin';

@Component({
  selector: 'app-callback',
  templateUrl: './callback.component.html',
  styleUrls: ['./callback.component.scss'],
  standalone: true,
  imports: [NzSpinModule]
})
export class CallbackComponent implements OnInit {
  // settingSrv: any;
  role: any;
  constructor(
    private Environment: EnvironmentconfigService,
    private webApiService: WebApiService,
    private msal: MsalService,
    private authServ: AuthService,
    private layoutServ: LayoutService,
    private msg: NzMessageService
  ) { }

  async ngOnInit() {
    try {
      this.msal.instance.enableAccountStorageEvents();
      let acc = this.msal.instance.getAllAccounts();
      while (!(acc?.length > 0)) {
        await new Promise(resolve => setTimeout(resolve, 200));
        acc = this.msal.instance.getAllAccounts();
      }
      this.msal.instance.setActiveAccount(acc[0]); //取得帳戶後，設定第一個帳戶為當前活動帳戶
      this.authServ.refreshToken().then(() => {
        //等token刷新完成
        if (acc.length > 0) {
          this.layoutServ.setUserInfo().then(async () => {
            const user = this.authServ.getCurrentUserInfo();
            if (!user || !user.email) {
              //导回login页面
              await new Promise<void>((resolve) => {
                setTimeout(() => { resolve(); }, 5000);
              });
              this.authServ.logoutAndClearAll();
              return;
            }

            //非緯創員工類型，即為廠商/客戶，更新最後登入時間 (只需要真實廠商登入才更新,IT人員使用Switch功能的不更新)
            if (user.userType !== 'User' && !this.authServ.getSwitchedToken()) {
              this.updateLatestLogin();
            }

            const redirectTo = this.authServ.consumeRedirectUrl();
            if (redirectTo) {
              window.location.href = redirectTo;
            } else {
              window.location.href = '/pages';
            }
          });
        }
      });
    }
    catch (error) {
      console.error('Error during redirect handling:', error);
    }
  }

  updateLatestLogin() {
    const url = `${this.Environment.authConfig.MVMBackEnd}${URLConst.UpdateLatestLogin.url}`;
    this.webApiService.doGet(url).subscribe(res => {
      if (!(res?.rc === 0 && res?.data)) {
        this.msg.error('Update latest login time failed');
        console.error('Update latest login time failed:', res?.msg);
      }
    });
  }
}
